module.exports = __webpack_public_path__ + "img/16_17.26e21fd9.png";